import { Col, Row } from 'reactstrap';
import { Select, SelectOptionType } from '@octano/global-ui';
import { StudentRiskPrimaryFiltersLoaderData } from './hooks/StudentRiskPrimaryFiltersLoader';
import { StudentsRiskHistoryLoader } from './hooks/StudentsRiskHistoryLoader';
import { useState } from 'react';
import { useTexts } from './hooks/useTexts';

export const PrimaryFilters = () => {
  const {
    defaultPeriod,
    periodOptions,
    defaultSchool,
    schoolOptions,
    defaultYear,
    yearOptions,
  } = StudentRiskPrimaryFiltersLoaderData();

  const texts = useTexts().primaryFilters;
  const { query, updateQuery } = StudentsRiskHistoryLoader();
  const [school, setSchool] = useState(defaultSchool);
  const [year, setYear] = useState(defaultYear);
  const [period, setPeriod] = useState(defaultPeriod);

  return (
    <Row className="d-flex justify-content-between align-items-center mt-4">
      <Col xs={12} md={4} className="mb-3 mb-md-0">
        <Select
          label={texts.school}
          name="school"
          value={school}
          options={schoolOptions}
          isClearable={false}
          onChange={(selectedSchool: SelectOptionType) => {
            setSchool(selectedSchool);
            updateQuery({
              ...query,
              page: 0,
              schoolId: selectedSchool.value,
            });
          }}
        />
      </Col>
      <Col xs={12} md={4} className="mb-3 mb-md-0">
        <Select
          label={texts.year}
          name="year"
          value={year}
          options={yearOptions}
          isClearable={false}
          onChange={(selectedYear: SelectOptionType) => {
            setYear(selectedYear);
            updateQuery({
              ...query,
              page: 0,
              year: selectedYear.value,
            });
          }}
        />
      </Col>
      <Col xs={12} md={4} className="mb-3 mb-md-0">
        <Select
          label={texts.period}
          name="period"
          value={period}
          options={periodOptions}
          isClearable={false}
          onChange={(selectedPeriod: SelectOptionType) => {
            setPeriod(selectedPeriod);
            updateQuery({
              ...query,
              page: 0,
              periodId: selectedPeriod.value,
            });
          }}
        />
      </Col>
    </Row>
  );
};
